import produce from "immer";
import { createAction, handleActions } from "redux-actions";
import {
  BreadcrumbState,
  CommonProps,
  GetPayload,
  homeMenuItemProps,
  menuItemProps,
} from "../types/commons";

/* =======================
 * Action Types
 * ======================= */
const INITIALIZE = "breadcrumb/INITIALIZE";
const SET_BREADCRUMB_LIST = "breadcrumb/SET_BREADCRUMB_LIST";
const SET_MENUITEM = "breadcrumb/SET_MENUITEM";
const SET_MENUTYPE = "breadcrumb/SET_MENUTYPE";
const SET_HOMEMENUITEM = "breadcrumb/SET_HOMEMENUITEM";

/* =======================
 * Action Creators
 * ======================= */
export const initialize = createAction(INITIALIZE);

export const setBreadcrumbListAction = createAction(
  SET_BREADCRUMB_LIST,
  (breadcrumbItems: BreadcrumbState["breadcrumbItems"]) => breadcrumbItems,
);

export const setMenuItemAction = createAction(
  SET_MENUITEM,
  ({ menuItem }: menuItemProps) => ({ menuItem }),
);

export const setMenuTypeAction = createAction(
  SET_MENUTYPE,
  ({ key, value }: CommonProps) => ({ key, value }),
);

export const setHomeMenuItemAction = createAction(
  SET_HOMEMENUITEM,
  ({ homeMenuItem }: homeMenuItemProps) => ({ homeMenuItem }),
);

/* =======================
 * Initial State
 * ======================= */
const initialState: BreadcrumbState = {
  breadcrumbItems: [],
  menuItem: "",
  menuType: {
    building: "list",
    floor: "list",
    room: "list",
    doorlock: "list",
    booking: "list",
    report: "list",
    staff: "list",
    blackList: "list",
    announcement: "list",
    termsTemplates: "list",
  },
  homeMenuItem: "",
};

/* =======================
 * Payload Helper Type
 * ======================= */
type Payloads = GetPayload<
  | typeof initialize
  | typeof setBreadcrumbListAction
  | typeof setMenuItemAction
  | typeof setMenuTypeAction
  | typeof setHomeMenuItemAction
>;

type MenuTypeKey = keyof BreadcrumbState["menuType"];

/* =======================
 * Reducer
 * ======================= */
const breadcrumb = handleActions<BreadcrumbState, Payloads>(
  {
    [INITIALIZE]: () => ({ ...initialState }),

    [SET_BREADCRUMB_LIST]: (state, { payload }) => ({
      ...state,
      breadcrumbItems: payload,
    }),

    [SET_MENUITEM]: (state, { payload }) => ({
      ...state,
      menuItem: payload.menuItem,
    }),

    [SET_MENUTYPE]: (state, { payload: { key, value } }) =>
      produce(state, (draft) => {
        draft.menuType[key as MenuTypeKey] = value;
      }),

    [SET_HOMEMENUITEM]: (state, { payload }) => ({
      ...state,
      homeMenuItem: payload.homeMenuItem,
    }),
  },
  initialState,
);

export default breadcrumb;
